import { render, staticRenderFns } from "./UpdateFaqTypePage.vue?vue&type=template&id=2cf1d1b2&scoped=true"
import script from "./UpdateFaqTypePage.vue?vue&type=script&lang=js"
export * from "./UpdateFaqTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1d1b2",
  null
  
)

export default component.exports